"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const timePerCootsFrame = 100;
exports.default = timePerCootsFrame;
